import React from 'react';
import classNames from 'classnames';
import { UseFormMethods } from 'react-hook-form';
import { LinkFields } from '../../types';
import { Info } from './Info';

export interface FieldProps {
  form: UseFormMethods<LinkFields>;
  name: keyof LinkFields;
  label: React.ReactNode;
  component: React.ReactElement;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  labelAside?: React.ReactNode;
  isOptional?: boolean;
  info?: React.ReactNode;
}

export const Field: React.FC<FieldProps> = ({
  form,
  name,
  label,
  component,
  isDisabled = false,
  isReadOnly = false,
  labelAside,
  isOptional = false,
  info,
}) => {
  const error = form.errors[name]?.message;
  const formComponent = React.cloneElement(component, {
    ref: form.register,
    name,
    isDisabled,
    isReadOnly,
    id: name,
  });
  return (
    <div
      className={classNames('form-row', {
        error,
      })}
    >
      <div className="flex-box-row flex-align-center">
        <label htmlFor={name}>
          {label}
          {isOptional && <span className="optional">(optional)</span>}
        </label>
        {error && <span className="error-msg">{error}</span>}
        {labelAside}
      </div>
      {formComponent}
      {info && <Info>{info}</Info>}
    </div>
  );
};
